import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["subtype"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { useQuery as useChatbotAuthQuery } from "@faire/web-api/api/help-center/chat-bot/auth/get-hooks";
import { route as supportSelfServeChatCsat } from "@faire/web-api/routes/support/self-serve/chat-csat";
import { WebApiError } from "@faire/web-api/WebApiError";
import { isProduction } from "@faire/web/common/user-agent/isProduction";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useChatbotMetadata } from "../useChatbotMetadata";
import { handleCommissionUpdateRequest } from "./handle/handleCommissionUpdateRequest";
import { handleDelayedMissingPayout } from "./handle/handleDelayedMissingPayout";
import { SubType } from "./responseTypes";
import { DECAGON_SCRIPT_URL } from "./types";
export var useDecagon = function useDecagon() {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var hasAIChatbotAccess = useAIChatbotAccess();
  var _useChatbotAuthQuery = useChatbotAuthQuery({
      enabled: hasAIChatbotAccess
    }),
    chatbotAuthResponse = _useChatbotAuthQuery.data;
  var metadata = useChatbotMetadata();
  var _ref = chatbotAuthResponse !== null && chatbotAuthResponse !== void 0 ? chatbotAuthResponse : {},
    signature = _ref.signature,
    expires_at = _ref.expires_at,
    user_token = _ref.user_token,
    jwt = _ref.jwt;
  useEffect(function () {
    if (pathname === supportSelfServeChatCsat) {
      return;
    }
    if (!signature || !expires_at || !user_token || !jwt) {
      return;
    }
    if (hasAIChatbotAccess) {
      var script = document.createElement("script");
      script.src = DECAGON_SCRIPT_URL;
      script.async = true;
      document.body.appendChild(script);
      script.addEventListener("load", function () {
        window.duet.setMetadata(_objectSpread(_objectSpread({}, metadata), {}, {
          token: jwt
        }));
        window.duet.setUserId(user_token);
        window.duet.setUserIdAuth(signature, expires_at);
        if (!isProduction()) {
          window.duet.setIsConversationUrlVisible(true);
        }
        window.duet.setMetadataRequestListener( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload, callback) {
            var subtype, args, _error$httpStatusCode;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  subtype = payload.subtype, args = _objectWithoutProperties(payload, _excluded);
                  _context.t0 = subtype;
                  _context.next = _context.t0 === SubType.REQUEST_COMMISSION_UPDATE ? 5 : _context.t0 === SubType.DELAYED_MISSING_PAYOUT ? 8 : 11;
                  break;
                case 5:
                  _context.next = 7;
                  return handleCommissionUpdateRequest(args, callback);
                case 7:
                  return _context.abrupt("return", _context.sent);
                case 8:
                  _context.next = 10;
                  return handleDelayedMissingPayout(args, callback);
                case 10:
                  return _context.abrupt("return", _context.sent);
                case 11:
                  return _context.abrupt("break", 12);
                case 12:
                  _context.next = 17;
                  break;
                case 14:
                  _context.prev = 14;
                  _context.t1 = _context["catch"](0);
                  if (_context.t1 instanceof WebApiError) {
                    callback({
                      ok: false,
                      status: (_error$httpStatusCode = _context.t1.httpStatusCode) !== null && _error$httpStatusCode !== void 0 ? _error$httpStatusCode : 500,
                      error: _context.t1.message
                    });
                  }
                case 17:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 14]]);
          }));
          return function (_x, _x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
      return function () {
        document.body.removeChild(script);
      };
    }
    return function () {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expires_at, hasAIChatbotAccess, jwt, signature, user_token]);
};